import type { FC } from 'react';

type JsonLdProps = {
  data: Record<string, unknown>;
};

export const JsonLd: FC<JsonLdProps> = ({ data }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};
